import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: 445,
    padding: 36,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%"
  },
  gridContainer: {
    marginTop: 12
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    padding: "24px 18px",
    justifyContent: "center",
    alignItems: "center"
  },
  label: {
    color: theme.palette.primaryGrey,
    ...theme.typography.h6,
  },
}));